import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { CoreDataActions } from '../state/core.data.actions';
import { Code } from '@jms/model';
import { Observable } from 'rxjs';
import { skipWhile, first } from 'rxjs/operators';


@Injectable()
export class CodeResolver  {
  items: Code[];

  constructor(private actions: CoreDataActions) {
    actions.codes$.subscribe(x => (this.items = x));
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (!this.items.length) this.actions.loadCodes();
    return this.actions.codes$.pipe(skipWhile(x => x == null), first());
  }
}
